module.exports = __webpack_public_path__ + "img/mobileHome.57b74d83.png";